module.exports = __webpack_public_path__ + "img/hinamori-logo-white.28e71e42.png";